export default __webpack_public_path__ + "static/media/Page_8.1e78f882.png";